import {
    Route,
    RouterProvider,
    createHashRouter,
    createRoutesFromElements,
} from 'react-router-dom';

import Layout from './components/Layout.tsx';
import Home from './pages/Home.tsx';
import PageLayout from './components/PageLayout.tsx';
import Accueil from './pages/Accueil.tsx';
import Regles from './pages/Regles.tsx';
import References from './pages/References.tsx';
import PlusInfos from './pages/PlusInfos.tsx';
import Credits from './pages/Credits.tsx';
import ModeLayout from './components/ModeLayout.tsx';
import Mode from './pages/Mode.tsx';
import Multi from './pages/Multi.tsx';
import JeuLayout from './components/JeuLayout.tsx';
import Jeu from './pages/Jeu.tsx';
import Questions from './pages/Questions.tsx';
import Fin from './pages/Fin.tsx';
import MentionsLegales from './pages/MentionsLegales.tsx';

function App() {
    const router = createHashRouter(
        createRoutesFromElements(
            <Route
                path='/'
                element={<Layout />}
            >
                <Route
                    index
                    element={<Home />}
                />
                <Route
                    path='accueil'
                    element={<PageLayout />}
                >
                    <Route
                        index
                        element={<Accueil />}
                    />
                    <Route
                        path='regles'
                        element={<Regles />}
                    />
                    <Route
                        path='references'
                        element={<References />}
                    />
                    <Route
                        path='plusinfos'
                        element={<PlusInfos />}
                    />
                    <Route
                        path='credits'
                        element={<Credits />}
                    />
                    <Route
                        path='mentionslegales'
                        element={<MentionsLegales />}
                    />
                </Route>
                <Route
                    path=':id'
                    element={<PageLayout />}
                >
                    <Route element={<ModeLayout />}>
                        <Route
                            index
                            element={<Mode />}
                        />
                        <Route
                            path='multi'
                            element={<Multi />}
                        />
                    </Route>

                    <Route
                        path=':jeu'
                        element={<JeuLayout />}
                    >
                        <Route
                            index
                            element={<Jeu />}
                        />
                        <Route
                            path='questions'
                            element={<Questions />}
                        />
                    </Route>
                    <Route
                        path='fin'
                        element={<Fin />}
                    />
                </Route>
            </Route>
        )
    );

    return <RouterProvider router={router} />;
}

export default App;
